document.addEventListener("DOMContentLoaded", function () {
  var cookieBanner = document.getElementById("cookie-banner");
  var acceptCookiesButton = document.getElementById("accept-cookies");
  var rejectCookiesButton = document.getElementById("reject-cookies");
  var closeBannerButton = document.getElementById("close-banner");

  // Verificar si las preferencias de cookies están almacenadas en sessionStorage
  if (
    sessionStorage.getItem("cookiesAccepted") === "true" ||
    sessionStorage.getItem("cookiesRejected") === "true"
  ) {
    cookieBanner.style.display = "none";
  } else {
    cookieBanner.style.display = "block";
  }

  // Manejar el clic en "Aceptar"
  acceptCookiesButton.addEventListener("click", function () {
    sessionStorage.setItem("cookiesAccepted", "true");
    sessionStorage.removeItem("cookiesRejected"); // Asegurarse de que "cookiesRejected" no esté presente
    cookieBanner.style.display = "none";
  });

  // Manejar el clic en "Rechazar"
  rejectCookiesButton.addEventListener("click", function () {
    sessionStorage.setItem("cookiesRejected", "true");
    sessionStorage.removeItem("cookiesAccepted"); // Asegurarse de que "cookiesAccepted" no esté presente
    cookieBanner.style.display = "none";
  });

  // Manejar el clic en "Cerrar"
  closeBannerButton.addEventListener("click", function () {
    cookieBanner.style.display = "none";
  });
});
